import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Input, DatePicker } from 'antd';
import MySegmented from '../../../components/segmented/Segmented.jsx';
import ModalComponent from '../../../components/modals/ModalComponent.jsx';
import TableWithSkeleton from "../../../components/table/TableWithSkeleton.jsx";
import Pagination from "../../../components/pagination/Pagination.jsx"
import columns from "../../../columns/InternalTransfer.js";
import Eye from "../../../assets/Eye.jsx";
import { GetAllwalletinternalTransferApi } from '../../../api/request/transfer';
import { formatDate } from '../../../utils/utils.js';
import { useResponsive } from '../../../hooks/useResponsive.js';
import Lock from '../../../assets/auth/Lock.jsx';
import toast from 'react-hot-toast';
import { ResendWithdrawTransactionApi, VerifyWithdrawTransactionApi } from '../../../api/request/wallet/withdraw.js';
import OTPModal from '../../../components/modals/OTPModal.jsx';

const { RangePicker } = DatePicker;

const TransferRequest = ({ isRefresh, setIsRefresh }) => {
    const { isMobile } = useResponsive();
    const { userDetails } = useSelector(state => state.user);
    const [filter, setFilter] = useState("Pending");
    const [data, setData] = useState([]);
    const [totalRecord, setTotalRecord] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(1);
    const [searchText, setSearchText] = useState('');
    const [search, setSearch] = useState('');
    const [dates, setDates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [sorter, setSorter] = useState({ SortBy: 'createdDate', SortOrder: '' });
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [transferDetails, setTransferDetails] = useState(null);
    const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
    const [pendingRequestId, setPendingRequestId] = useState(null);
    const [otp, setOtp] = useState("");
    const [otpLoading, setOtpLoading] = useState(false);

    const getFilteredColumns = (statusFilter) => {
        if (statusFilter === 'Pending') {
            return columns.filter((column) => column?.dataIndex !== 'actionDate');
        }
        return columns;
    };

    const getAllInternalTransfer = async () => {
        setIsLoading(true);
        try {
            const params = {
                userId: userDetails?._id,
                PageNumber: page,
                PageSize: pageSize,
                SearchText: searchText,
                FromDate: dates?.length === 2 ? dates[0].format('MM-DD-YYYY') : '',
                ToDate: dates?.length === 2 ? dates[1].format('MM-DD-YYYY') : '',
                FilterText: filter === "Approved" ? "Success" : filter,
                ...sorter
            };

            const { data } = await GetAllwalletinternalTransferApi(new URLSearchParams(params).toString());
            if (data?.success) {
                setData(
                    data?.data?.map((item) => {
                        return {
                            ...item,
                            name: `${item?.firstName} ${item?.lastName}`,
                            amount: `$ ${item?.amount}`,
                            createdDate: formatDate(item?.createdDate) || '--',
                            actionDate: formatDate(item?.actionDate) || '--',
                            actions: (
                                <div className="flex items-center gap-2">
                                    <button
                                        type="button"
                                        onClick={() => {
                                            setTransferDetails(item);
                                            setIsModalOpen(true);
                                        }}
                                    >
                                        <Eye />
                                    </button>
                                    {
                                        item?.isOTPVerify === false && (
                                            <button type="button" onClick={() => { setPendingRequestId(item?.id); setOtp(""); setIsOTPModalOpen(true); handleOtpResend(item?.id); }} title="Verify OTP" aria-label="Verify OTP">
                                                <Lock />
                                            </button>
                                        )
                                    }
                                </div>
                            ),
                        };
                    })
                );
                setTotalRecord(data?.totalRecords);
                setIsRefresh(false);
            }
        } catch (error) {
        } finally {
            setIsLoading(false);
        }
    }
    const handleOtpSubmit = async (otpVal) => {
        try {
            setOtpLoading(true);
            const params = { requestId: pendingRequestId, otp: otpVal, actionType: 2 };
            const { data } = await VerifyWithdrawTransactionApi(params);
            if (data?.success) {
                toast.success(data?.message || 'Withdrawal verified successfully');
                setIsOTPModalOpen(false);
                setOtp("");
                getAllInternalTransfer();
            } else {
                toast.error(data?.message || 'Failed to verify OTP');
            }
        } catch (err) {
        } finally {
            setOtpLoading(false);
        }
    };
    const handleOtpResend = async (requestIdArg) => {
        try {
            setOtp("");
            const id = requestIdArg ?? pendingRequestId;
            if (!id) {
                toast.error('Missing request id');
                return false;
            }
            const params = { requestId: id, actionType: 2 };
            const { data } = await ResendWithdrawTransactionApi(params);
            if (data?.success) {
                toast.success(data?.message || 'OTP resent');
                return true;
            }
            toast.error(data?.message || 'Failed to resend OTP');
            return false;
        } catch (err) {
            return false;
        }
    };

    useEffect(() => {
        getAllInternalTransfer();
    }, [page, pageSize, searchText, dates, filter, sorter, isRefresh]);

    const handleSubmitnew = (event) => {
        event.preventDefault();
        getAllInternalTransfer();
    };

    const handleTableChange = (pagination, filters, sorter) => {
        if (sorter?.order) {
            setSorter({ SortBy: sorter?.field, SortOrder: sorter?.order });
        } else {
            setSorter({ SortBy: 'createdDate', SortOrder: '' });
        }
    };

    return (
        <div>
            <div className="block md:flex flex-wrap justify-between items-center gap-5">
                <MySegmented
                    block={isMobile}
                    options={["Pending", "Approved", "Rejected"]}
                    value={filter}
                    setValue={(value) => {
                        setFilter(value);
                        setPage(1);
                    }}
                />

                <div className='flex flex-col md:flex-row md:items-center gap-3 mt-5 md:mt-0'>
                    <form autoComplete="off" onSubmit={handleSubmitnew}>
                        {!isMobile ? (
                            <div>
                                <RangePicker
                                    className="py-4 sm:py-1.5 rounded-lg w-full sm:w-auto"
                                    format="DD-MM-YYYY"
                                    onChange={(dates) => setDates(dates)}
                                />
                            </div>
                        ) : (
                            <div className="flex justify-between gap-4 w-full">
                                <DatePicker
                                    onChange={(date) => {
                                        setDates([date, dates[1]]);
                                    }}
                                    placeholder="From Date"
                                    className="w-full rounded-xl py-3"
                                />
                                <DatePicker
                                    onChange={(date) => {
                                        setDates([dates[0], date]);
                                    }}
                                    placeholder="To Date"
                                    className="w-full rounded-xl py-3"
                                />
                            </div>
                        )}
                    </form>

                    <Input
                        size="large"
                        {...(!isMobile && { style: { width: 220 } })}
                        placeholder="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        onPressEnter={() => setSearchText(search)}
                        prefix={
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
                                <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clip-rule="evenodd" />
                            </svg>
                        }
                        suffix={search &&
                            <svg xmlns="http://www.w3.org/2000/svg" onClick={() => { setSearchText(''); setSearch('') }} viewBox="0 0 24 24" fill="#bebebe" className="size-5 cursor-pointer duration-300 hover:fill-[#969595]">
                                <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" />
                            </svg>
                        }
                    />
                </div>
            </div>

            <div className="mt-6">
                <div className="border border-gray-200 rounded-xl">
                    <TableWithSkeleton columns={getFilteredColumns(filter)} data={data} loading={isLoading} onChange={handleTableChange} />
                </div>

                <Pagination total={totalRecord} pageSize={pageSize} setPageSize={setPageSize} page={page} setPage={setPage} />
            </div>

            <ModalComponent isOpen={isModalOpen} setIsOpen={setIsModalOpen} title="InternalTransfer Information" width={1300}>
                <div className='p-5'>
                    <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10'>
                        <div>
                            <p className='text-base font-normal'>Wallet Account No.</p>
                            <p className='text-xl primary font-semibold mt-2'>{transferDetails?.walletAccountNo || "--"}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Wallet Balance</p>
                            <p className='text-xl primary font-semibold mt-2'>$ {transferDetails?.availableWalletBalance}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Account No</p>
                            <p className='text-xl primary font-semibold mt-2'>{transferDetails?.accountNo || "--"}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Amount</p>
                            <p className='text-xl primary font-semibold mt-2'>$ {transferDetails?.amount || "--"}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Status</p>
                            <p className='text-xl primary font-semibold mt-2'>{transferDetails?.status || '--'}</p>
                        </div>
                        <div>
                            <p className='text-base font-normal'>Request Date</p>
                            <p className='text-xl primary font-semibold mt-2'>{formatDate(transferDetails?.createdDate) || "--"}</p>
                        </div>
                        {transferDetails?.status !== "Pending" ? <div>
                            <p className='text-base font-normal'>Action Date</p>
                            <p className='text-xl primary font-semibold mt-2'>{formatDate(transferDetails?.actionDate) || "--"}</p>
                        </div> : ""}
                        <div className='col-span-full'>
                            <p className='text-base font-normal'>Comment</p>
                            <p className='text-xl primary font-semibold mt-2'>{transferDetails?.remarks || "--"}</p>
                        </div>
                    </div>
                </div>
            </ModalComponent>

            <OTPModal
                isOpen={isOTPModalOpen}
                setIsOpen={setIsOTPModalOpen}
                title='OTP Verification'
                message='Please enter the OTP to verify withdrawal request.'
                width={600}
                value={otp}
                onChange={(val) => setOtp(val)}
                onSubmit={handleOtpSubmit}
                onResend={handleOtpResend}
                isLoading={otpLoading}
                loadingLabel='Verifying...'
                submitLabel='Verify'
                otpDuration={120}
            />
        </div>
    )
}

export default TransferRequest